import { Container, Image } from "react-bootstrap"
import "./style.scss"
import { useTranslation } from "react-i18next";

export const Guide = () => {

    const {t} = useTranslation('translations');
    return (
        <Container className="guide">
            <h1>{t('txt26')}</h1>

            
            <ul className="table-content">
                <li><span>[Quick jump]</span></li>
                <li><a href="#how-to-login">{t('txt27')}</a></li>
                <li><a href="#how-to-buy-chip">{t('txt32')}</a></li>
                <li><a href="#how-to-sell-chip">{t('txt38')}</a></li>
            </ul>

            <div id="how-to-login">
                <h4>{t('txt27')}</h4>
                <div className="step">
                    <div className="title">{t('txt28')}</div>
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-login-1.png" />
                </div>
                <div className="step">
                    <div className="title">{t('txt29')}</div>
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-login-2.png" />
                </div>
                <div className="step">
                    <div className="title">{t('txt30')}</div>
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-login-3.png" />
                </div>
                <div className="step">
                    <div className="title">{t('txt31')}</div>
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-login-4.png" />
                </div>
            </div>

            <div id="how-to-buy-chip">
                <h4>{t('txt32')}</h4>
                <div className="step">
                    <div className="title">{t('txt33')}</div>
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-buy-chip-1.png" />
                </div>
                <div className="step">
                    <div className="title">{t('txt34')}</div>
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-buy-chip-2.png" />
                </div>
                <div className="step">
                    <div className="title">{t('txt35')}</div>
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-buy-chip-3.png" />
                </div>
                <div className="step">
                    <div className="title">{t('txt36')}</div>
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-buy-chip-4.1.png" />
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-buy-chip-4.2.png" />
                </div>

                <div className="step">
                    <div className="notice">
                        {t('txt37')}    
                    </div>
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-buy-chip-5.1.png" />
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-buy-chip-5.2.png" />
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-buy-chip-5.3.png" />
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-buy-chip-5.4.png" />
                </div>

            </div>

            <div id="how-to-sell-chip">
                <h4>{t('txt38')}</h4>
                <div className="step">
                    <div className="title">{t('txt39')}</div>
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-sell-chip-1.png" />
                </div>
                <div className="step">
                    <div className="title">{t('txt40')}</div>
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-sell-chip-2.png" />
                </div>
                <div className="step">
                    <div className="title">{t('txt41')}</div>
                    <Image src="https://cdnphpgames.com/api/public/dl/JZd6qPc5/guide/v1/how-to-sell-chip-3.png" />
                </div>
            </div>
        </Container>
    )
}